import { useMemo } from 'react';

import { mathFormat, financeFormat, getChartBufferWidth, toTwoDecimalNumber } from './common';
import { isArray } from 'lodash';
import { format } from 'prettier';
type EChartsOptions = echarts.EChartsOption;

export type ChartOptionsType = {
  userOptions: EChartsOptions;
  type?: 'line' | 'bar' | 'pie' | 'treemap';
  pieLabelAlignTo?: 'none' | 'labelLine' | 'edge';
  noMerge?: boolean;
  pieValueFormat?: (value: number) => any;
  excludeOptions?: Array<
    'tooltip' | 'grid' | 'legend' | 'color' | 'xAxis' | 'yAxis' | 'axisPointer'
  >; // 排除部分属性合并
  handleShow?: boolean; // 点击的时候选中态
  xAxisLabelInterval?: //  坐标轴刻度标签的显示间隔
  'auto' | number | ((index: number, value: string) => boolean);
  selectedMode?: boolean;
  pieTotal?: number;
  numberType?: string; // 数据类型
  formatType?: 'million' | 'bmk'; // 数值格式化方式: 'million'=固定M, 'bmk'=BMK自适应(K/M/B)
};

/**
 * TODO: 其他系统使用
 * 计算百分比字符串
 * @param value          数值
 * @param total          总数
 * @param precision      精度
 * @param defaultValue   默认值
 * @returns
 */
export function getPercentageInfo(
  value: number,
  total: number,
  precision = 0,
  defaultValue = '-',
) {
  if (total) {
    // 100%直接展示100%
    if (total === value) {
      return '100%';
    }

    if (value === 0) {
      return '0%';
    }
    return ((value / total) * 100).toFixed(precision) + '%';
  }

  return `${defaultValue}`;
}
export function isNilOrEmpty(value: any): boolean {
  return (
    value === null || value === undefined || value === '' || Number.isNaN(value)
  );
}
export const chartAllColors = [
  '#5EC8F1',
  '#7F6FF1',
  '#FC8B00',
  '#F7A2E3',
  '#7f6ff1',
  '#5ec8f1',
  '#ad53d4',
  '#f19e55',
  '#488e89',
  '#f17c86',
];
export const chartAllColorsObj: { [key: string]: string } = {
  'Capability Box': '#5EC8F1',
  'Dev Cost': '#5EC8F1',
  studio: '#7F6FF1',
  // studio: '#5EC8F1',
  'Publishing HC': '#7F6FF1',
  publishing: '#5EC8F1',
  casual: '#69D19C',
  'Mkt Cost': '#7F6FF1',
  'Other Cost': '#6e7794ff',
  'Full Year KPI Avg.': '#FC8B00',
  'KPI': '#FC8B00',
  actual_total: '#7F6FF1',
  'kpi': '#FC8B00',
  'Cum. Profit / Break even': '#FC8B00',
  'Revenue': '#F7A2E3',
  'Studios': '#6E7794',
  'total': '#7F6FF1',
  'Publishing Business': '#7F6FF1',
  'Tech/Publishing Support': '#5EC8F1',
  'IEGG Public': '#6E7794',
  'Studios Business': '#69D19C',
};

// Order-based colors - use with index instead of key
// Usage: chartOrderedColors[index] where index is 0-based
export const chartOrderedColors = [
  '#7F6FF1', // 1st item - purple
  '#5EC8F1', // 2nd item - cyan
  '#6E7794', // 3rd item - gray
  '#69D19C', // 4th item - green
  '#5086F3', // 5th item - blue
  '#F8D74D', // 6th item - yellow
  '#AD53D4', // 7th item - purple
  '#488E89', // 8th item - teal
  '#F19E55', // 9th item - orange
  '#F17C86', // 10th item - pink
  '#D2C8FD', // 11th item - light purple
  '#B5EFFF', // 12th item - light cyan
  '#B8BED1', // 13th item - light gray
  '#C0EBD2', // 14th item - light green
  '#A6C9FF', // 15th item - light blue
  '#FFF196', // 16th item - light yellow
  '#DFB2ED', // 17th item - light pink
  '#A9C7C3', // 18th item - light teal
  '#FFCCCC', // 19th item - light red
];

export const chartAllStudioColors = [
  '#7F6FF1',
  '#5EC8F1',
  '#FC8B00',
  '#69D19C',
  '#5086F3',
  '#F8D74D',
  '#AD53D4',
  '#488E89',
  '#F19E55',
  '#F17C86',
  '#D2C8FD'
];
export const chartNOAllStudioColors = [
  'rgba(127, 111, 241, .3)',
  'rgba(94, 200, 241, .3)',
  'rgba(110, 119, 148, .3)',
  'rgba(105, 209, 156, .3)',
  'rgba(80, 134, 243, .3)',
  'rgba(248, 215, 77, .3)',
  'rgba(173, 83, 212, .3)',
  'rgba(72, 142, 137, .3)',
  'rgba(241, 158, 85, .3)',
  'rgba(241, 124, 134, .3)',
  'rgba(210, 200, 253, .3)'
];
export const chartGradientNOColors = [
  [
    'rgba(140, 226, 255, 1)',
    'rgba(86,188,230,1)'
  ],
  [
    'rgba(173,158,255,0.3)',
    'rgba(104,91,194,0.3)'
  ],
];

export const chartGradientColors = [
  [
    'rgba(140, 226, 255, 1)',
    'rgba(86,188,230,1)'
  ],
  [
    'rgba(173, 158, 255, 1)',
    'rgba(104, 91, 194, 1)'
  ],
];
export const chartGradientNOColorsObj: { [key: string]: string[] } = {
  Actual: [
    'rgba(140, 226, 255, 0.3)',
    'rgba(86,188,230,0.3)'
  ],
  Forecast: [
    'rgba(173,158,255,0.3)',
    'rgba(104,91,194,0.3)'
  ],
  studio: [
    'rgba(140, 226, 255, .3)',
    'rgba(86,188,230, .3)'
  ],
  publishing: [
    'rgba(173,158,255,0.3)',
    'rgba(104,91,194,0.3)'
  ],
  ForeCast: [
    'rgba(173,158,255,0.3)',
    'rgba(104,91,194,0.3)'
  ],
};
export const chartGradientColorsObj = {
  Actual: [
    'rgba(140, 226, 255, 1)',
    'rgba(86,188,230,1)'
  ],
  Forecast: [
    'rgba(173, 158, 255, 1)',
    'rgba(104, 91, 194, 1)'
  ],
};


export const chartStudioGradientColors = [
  [
    '#FC8B00',
    '#FC8B00'
  ],
  [
    'rgba(173, 158, 255, 1)',
    'rgba(104, 91, 194, 1)'
  ],
];

// Shared ECharts data-label styling for readable text over bars/lines/axes.
export const CHART_DATA_LABEL_STYLE = {
  fontSize: 12,
  fontWeight: 'normal' as const,
  color: '#525464',
  textBorderColor: '#FFFFFF',
  textBorderWidth: 3,
};

export const mergeChartDataLabelStyle = (
  label?: Record<string, unknown>,
): Record<string, unknown> => ({
  ...CHART_DATA_LABEL_STYLE,
  ...(label || {}),
});

export const dealTypeValue = (
  type: string | undefined,
  value: number | string | null | undefined,
) => {
  // Handle null/undefined values
  if (value === null || value === undefined) {
    return '-';
  }

  const typeobj = {
    percent: '%',
    num: '',
    integer: '',
  };
  if (type === 'integer') {
    const numericValue = Number(value);
    if (!Number.isFinite(numericValue)) {
      return '-';
    }
    return `${Math.round(numericValue)}`;
  }
  const suffix = type ? typeobj[type as keyof typeof typeobj] || '' : '';
  return `${toTwoDecimalNumber(value)}${suffix}`
}

export function useChartOptions({
  userOptions,
  type = 'line',
  pieLabelAlignTo = 'edge',
  excludeOptions = [],
  noMerge = false,
  handleShow = false,
  xAxisLabelInterval = 'auto',
  pieValueFormat = mathFormat,
  selectedMode = false,
  pieTotal,
  numberType,
  formatType = 'million',
}: ChartOptionsType) {
  // Pick the chart value formatter based on formatType.
  // 'million' → fixed M (millions), 'bmk' → BMK auto-scaling (K/M/B).
  const formatChartValue = (value: string | number): string =>
    formatType === 'bmk' ? financeFormat(value, 1) : mathFormat(value);
  // legend受到series的itemStyle影响较大
  const commonItemStyle = {
    borderColor: '#fff',
    borderWidth: 1,
  };

  let commonOptions: any = useMemo(() => {
    let options: any = {
      tooltip: {
        trigger: 'axis',
        // backgroundColor: 'rgb(0,0,0)',
        textStyle: {
          color: 'rgb(255,255,255)',
        },
        formatter: (params: any[]) => {
          // 判断是否为默认添加的值
          const flag = params.every((el: any) => el.value === undefined)
          if (flag) return '';
          // Keep tooltip width/header stable when legend toggle changes params order.
          const widthSourceItem = params.find(
            (item: any) => item?.data?.tooltipWidth,
          );
          // Prefer a point that carries Portfolio header fields; null-valued
          // stacked series used to be bare `null` and stole params[0].
          const headerSourceItem = params.find(
            (item: any) => item?.data?.title
              || item?.data?.tooltipHeaderRight
              || item?.data?.date
              || item?.data?.names,
          ) || params[0];
          const headerData = headerSourceItem?.data || {};
          // Optional tooltip title line (e.g. Portfolio studio_name). Absent on Studios.
          const tooltipTitle = headerData.title;
          // When title is set, date row uses API date only — never fall back to axis label.
          const headerLeft = tooltipTitle
            ? (headerData.date || '')
            : `${headerSourceItem?.name || ''}${headerData.tooltipTitleSuffix || ''}`;
          const resolvedTooltipWidth = widthSourceItem?.data?.tooltipWidth
            || (tooltipTitle ? '240px' : (headerData.names ? '210px' : '170px'));
          return !flag && `<div style="width: ${resolvedTooltipWidth};font-size: 12px;line-height:14px;">
                ${tooltipTitle
              ? `<div style="color:#EBECF1;margin-bottom:10px;word-break:break-word;">${tooltipTitle}</div>`
              : ''}
                <div style="display:flex; justify-content: space-between;color: #D8DAE4; margin-bottom:10px;">
                  <div style="min-width: 80px;">${headerLeft}</div>
                  ${headerData.tooltipHeaderRight
              ? `<div style="text-align:right;">${headerData.tooltipHeaderRight}</div>`
              : (headerData.names?.split(',').map((item: string) => {
                return `<div style="text-align: center">${item || ''}</div>`
              }).join('') || '')}
            </div>
           
          ${params.map((item: any, index: number) => {
                const itemData = item?.data || {};
                if (itemData.render) {
                  return itemData.render(item);
                }
                const displayValue = itemData.tooltipValue ?? item.value;
                const hasDisplayValue = displayValue !== null && displayValue !== undefined;
                const formattedValue = hasDisplayValue
                  ? (itemData.valueType || numberType
                    ? dealTypeValue(itemData.valueType || numberType, displayValue)
                    : formatChartValue(displayValue))
                  : 'NA';
                const safeFormattedValue = formattedValue ?? 'NA';
                const numericDisplayValue = Number(displayValue);
                // Shared tooltip rule: negative numeric values are red by default.
                // Per-page custom color can still override via itemData.textColor.
                const defaultTooltipValueColor =
                  hasDisplayValue && Number.isFinite(numericDisplayValue)
                    ? (numericDisplayValue < 0 ? '#FF7777' : '#EBECF1')
                    : '#EBECF1';
                const resolvedTooltipValueColor =
                  itemData.textColor || defaultTooltipValueColor;
                const includeSeriesNames = Array.isArray(itemData.totalFromVisibleIncludeSeriesNames)
                  ? itemData.totalFromVisibleIncludeSeriesNames
                  : [];
                const excludeSeriesNames = Array.isArray(itemData.totalFromVisibleExcludeSeriesNames)
                  ? itemData.totalFromVisibleExcludeSeriesNames
                  : [];
                const totalFromVisibleParams = params.filter((tooltipItem: any) => {
                  const seriesName = tooltipItem?.seriesName;
                  if (
                    includeSeriesNames.length
                    && !includeSeriesNames.includes(seriesName)
                  ) {
                    return false;
                  }
                  if (excludeSeriesNames.includes(seriesName)) {
                    return false;
                  }
                  const visibleValue =
                    tooltipItem?.data?.tooltipValue ?? tooltipItem?.value;
                  // Exclude null-like values first; Number(null) and Number('') become 0
                  // and would incorrectly produce "0.0M" for all-empty totals.
                  if (
                    visibleValue === null
                    || visibleValue === undefined
                    || visibleValue === ''
                  ) {
                    return false;
                  }
                  return Number.isFinite(Number(visibleValue));
                });
                const visibleSeriesTotal = totalFromVisibleParams.reduce(
                  (sum: number, tooltipItem: any) => {
                    const visibleValue =
                      tooltipItem?.data?.tooltipValue ?? tooltipItem?.value;
                    return sum + Number(visibleValue);
                  },
                  0,
                );
                const formatVisibleSeriesTotal = (total: number) => {
                  // Allow per-chart override for dynamic total formatting.
                  // Fallback remains mathFormat for monetary charts.
                  if (typeof itemData.totalFromVisibleFormatter === 'function') {
                    return itemData.totalFromVisibleFormatter(total);
                  }
                  if (itemData.totalFromVisibleValueType) {
                    return dealTypeValue(itemData.totalFromVisibleValueType, total);
                  }
                  return formatChartValue(total);
                };
                const resolvedTotalShowContent = itemData.totalFromVisible
                  ? (
                    totalFromVisibleParams.length
                      ? formatVisibleSeriesTotal(visibleSeriesTotal)
                      : 'NA'
                  )
                  : itemData.totalShowContent;
                const resolvedTotalNumericValue = itemData.totalFromVisible
                  ? (
                    totalFromVisibleParams.length
                      ? visibleSeriesTotal
                      : null
                  )
                  : (
                    Number.isFinite(Number(itemData.totalShowValue))
                      ? Number(itemData.totalShowValue)
                      : (Number.isFinite(Number(itemData.totalShowContent))
                        ? Number(itemData.totalShowContent)
                        : null)
                  );
                const hasResolvedTotalShowContent =
                  resolvedTotalShowContent !== null
                  && resolvedTotalShowContent !== undefined
                  && resolvedTotalShowContent !== '';
                const resolvedTotalValueColor =
                  Number.isFinite(Number(resolvedTotalNumericValue))
                    ? (Number(resolvedTotalNumericValue) < 0 ? '#FF7777' : '#EBECF1')
                    : '#EBECF1';
                const rawMarkerHtml = String(item?.marker || '');
                const markerColorMatch = rawMarkerHtml.match(
                  /background(?:-color)?:\s*([^;"]+)/i,
                );
                const markerColorFromHtml = markerColorMatch?.[1]?.trim();
                const tooltipMarkerColor = markerColorFromHtml
                  || (typeof item?.color === 'string' ? item.color : '')
                  || '#7F6FF1';
                const tooltipMarker = `<span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:${tooltipMarkerColor};margin-right:6px;"></span>`;
                return `${hasResolvedTotalShowContent && index === 0 ?
                  `<div class="dbs-base-chart-tooltip-item" style="display: flex;justify-content: space-between;">
                  <span class="dbs-base-chart-tooltip-item-name">
                    ${itemData.totalTitleMarker || ''}
                    <span style="font-size: 13px">${itemData.totalTitleText || 'Total'}</span>
                  </span>
                  <span class="dbs-base-chart-tooltip-item-value">
                    <span style="font-size: 14px;font-weight: 600; color: ${resolvedTotalValueColor}">${resolvedTotalShowContent}</span>
                  </span>
                </div>` : ''}
                ${hasResolvedTotalShowContent && itemData.headSplit ? `<div style="height: 1px; width: 100%;background-color: rgba(255, 255, 255, 0.4);margin: 10px 0px 0px 0px"></div>` : ''}
                <div class="dbs-base-chart-tooltip-item" style="display: flex;justify-content: space-between;margin-top:10px">
                  <span class="dbs-base-chart-tooltip-item-name">
                    ${tooltipMarker}
                    <span>${item.seriesName}</span>
                  </span>
                  <span class="dbs-base-chart-tooltip-item-value">
                    <span style="font-size: 14px;font-weight: 600; color: ${resolvedTooltipValueColor}">${safeFormattedValue}</span>
                    ${itemData.tip || ''}
                  </span>
                </div>
              `
              }).join('')}
          </div>`
        },
        enterable: false,
        className: 'dbs-base-chart-tooltip',
        // formatter: "{b0}<br/> {a0}:{c0} <br/>{a1}:{c1} <br/>{a2}:{c2}",
        borderWidth: 0,
        borderRadius: 6,
        confine: true, // 是否将弹窗限制再图表内
        // appendToBody: true, 将弹窗添加到body上
        // enterable: true, 是否允许鼠标进入弹窗
        hideDelay: 200,
        triggerOn: 'mousemove',
        padding: 0,
        axisPointer: {
          animation: false,
          type: type === 'line' ? 'line' : 'shadow',
        },
      },
      axisPointer: {
        link: { xAxisIndex: 'all' },
        label: {
          backgroundColor: '#fff',
          show: true,
          fontSize: 14,
          color: '#262832',
          fontWeight: 700,
          margin: 8,
          padding: [1, 7],
        },
        lineStyle: {
          type: 'solid',
          color: handleShow
            ? 'rgba(38, 40, 50, 0.55)'
            : 'rgba(38, 40, 50, 0.25)',
        },
        handle: {
          show: handleShow,
          opacity: 0,
        },
      },
      grid: {
        left: getChartBufferWidth(12),
        right: 7,
        bottom: '35px',
        top: 6,
        containLabel: true,
      },
      legend: {
        type: 'scroll',
        icon: 'circle',
        selectedMode: true,
        orient: 'horizontal',
        itemHeight: 8,
        itemWidth: 8,
        bottom: 0,
        itemGap: 18,
        inactiveBorderWidth: 0,
        inactiveBorderColor: '#fff',
        pageIconColor: 'rgb(47, 69, 84)', //翻页下一页的三角按钮颜色
        pageIconInactiveColor: 'rgb(170, 170, 170)', //翻页（即翻页到头时）
        pageIconSize: 12, //翻页按钮大小
        pageButtonPosition: 'end', //start
        textStyle: {
          color: '#888888',
          fontSize: 12,
          height: 14,
          lineHeight: 14,
          rich: {
            // ...channelLegendRichInfo(16, 16),
            name: {
              width: 14,
              height: 14,
              lineHeight: 14,
              verticalAlign: 'middle',
              padding: [2, 0, 0, 0],
            },
          },
          verticalAlign: 'middle', // 文本垂直对齐方式
        },
        itemStyle: commonItemStyle,
        padding: [2, 0, 2, 0],
        selectorLabel: {
          verticalAlign: 'middle',
        },
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        axisLabel: {
          color: '#838697',
          fontSize: 12,
          align: 'center',
          interval: xAxisLabelInterval,
        },
        axisTick: {
          alignWithLabel: true,
        },
        axisLine: {
          lineStyle: {
            type: 'solid',
            color: '#D8DAE4',
            width: 1, //坐标线的宽度
          },
          onZero: false,
        },
        axisPointer: {
          label: { show: !excludeOptions.includes('axisPointer') },
        },
      },
      yAxis: {
        type: 'value',
        alignTicks: true, // 轴线对齐
        splitLine: {
          show: true,
          lineStyle: {
            type: 'dashed',
            color: '#E5E5E5',
          },
        },
        axisLabel: {
          color: '#838697',
          fontSize: 12,
          formatter: function (value: number, index: number) {
            // 例如，将数字转换为带有千分位的字符串
            return numberType ? dealTypeValue(numberType, value) : `${formatChartValue(value)}`;
          }
        },
      },
      color: chartAllColors,
    };
    if (type === 'pie') {
      // 这个影响到tooltip弹窗
      delete options.tooltip.trigger;
    }
    // if(type === 'bar') {
    //   // chartGradientColors
    // }
    return options;
  }, [type, formatType]);

  // 这里得饼图配置会覆盖默认配置
  const commonPieOptions = {
    type: 'pie',
    radius: ['40%', '60%'],
    top: 10,
    bottom: 10,
    label: {
      color: '#262832',
      alignTo: pieLabelAlignTo,
      formatter: (params: any) => {
        // hooks参数传入total
        // series添加total | 占比
        // commonPieOptions提取为方法，在饼图页面调用
        const { value, percent, name } = params || {};
        let realPercent = percent.toFixed(2) + '%';
        if (!isNilOrEmpty(pieTotal)) {
          realPercent = getPercentageInfo(value, pieTotal || 0, 2);
        }
        return `{value|${name} }：{a|${pieValueFormat(
          value,
        )}(${realPercent})}\n{hr|}\n{a|}`;
      },
      edgeDistance: '20%',
      distanceToLabelLine: '0',
      rich: {
        a: {
          color: '#262832',
          lineHeight: 20, //设置最后一行空数据高度，为了能让延长线与hr线对接起来
          align: 'center',
        },
        hr: {
          //设置hr是为了让中间线能够自适应长度
          borderColor: 'auto', //hr的颜色为auto时候会主动显示颜色的
          width: '102%',
          borderWidth: 1,
          height: 0,
        },
        per: {
          //用百分比数据来调整下数字位置，显的好看些。如果不设置，formatter最后一行的空数据就不需要
          padding: [4, 0],
        },
      },
    },
    labelLine: { width: 2 },
    emphasis: { focus: 'series' },
    selectedMode: selectedMode,
  };

  const commonLineOptions = {
    symbol: 'circle',
    showSymbol: true,
    symbolSize: 9,
    emphasis: {
      // focus: 'series',
      itemStyle: {
        borderColor: '#fff',
        borderWidth: 1,
        borderType: 'solid',
        opacity: 1,
      },
    },
  };

  const commonBarOptions = {
    barMaxWidth: 80,
    // emphasis: {
    //   focus: 'series',
    // },
  };

  const optionsTypeMap = {
    pie: ['tooltip', 'grid', 'legend', 'color'],
    bar: [
      'yAxis',
      'tooltip',
      'grid',
      'legend',
      'color',
      'xAxis',
      'axisPointer',
    ],
    line: [
      'tooltip',
      'grid',
      'legend',
      'color',
      'xAxis',
      'yAxis',
      'axisPointer',
    ],
    treemap: ['tooltip', 'legend'],
  };

  const isObject = (obj: any) => typeof obj === 'object' && !Array.isArray(obj);
  const getCommonItemStyle = (item: any, itemStyle = {}) => {
    return {
      ...(item?.itemStyle || {}),
      ...commonItemStyle,
      ...itemStyle,
    };
  };

  const mergeSeriesOptions = ({
    resultOptions,
    commonOptions,
    specialItemStyle = {},
  }: {
    resultOptions: any;
    commonOptions: any;
    specialItemStyle?: any;
  }) => {
    // 统一参数
    let series = resultOptions.series;
    if (!Array.isArray(series)) {
      series = [series];
    }
    // 统一参数
    const getOptionsFunc =
      typeof commonOptions === 'function' ? commonOptions : () => commonOptions;

    return series.map((item: any) => {
      let noItemStyle = item?.type === 'bar';
      const { data, ...otherOptions } = getOptionsFunc(item);
      return {
        ...otherOptions,
        ...(item || {}),
        data: data || item?.data,
        itemStyle: noItemStyle
          ? { ...(item?.itemStyle || {}) }
          : getCommonItemStyle(item, specialItemStyle),
      };
    });
  };

  const dealwithPie = (resultOptions: any) => {
    // 对饼图进行圆角等操作
    if (type === 'pie') {
      resultOptions.series = mergeSeriesOptions({
        resultOptions,
        commonOptions: commonPieOptions,
        specialItemStyle: { borderRadius: 6 },
      });
    }
  };

  const dealwithBarLine = (resultOptions: any) => {
    // 对饼图进行圆角等操作
    if (type !== 'pie') {
      resultOptions.series = mergeSeriesOptions({
        resultOptions,
        commonOptions: (item: any) => {
          const isLineItem = item?.type === 'line';
          let data = item?.data || [];
          // if (isLineItem) {
          //   data = dealwithLineSymbol(data);
          // }
          return {
            ...(isLineItem ? commonLineOptions : commonBarOptions),
            ...item,
            data: data,
          };
        },
      });
    }
  };

  function mergeObjOptions(
    commonOption: { [key: string]: any },
    userOption: { [key: string]: any },
  ) {
    const option: any = {};
    for (const key in commonOption) {
      let common = commonOption[key];
      let user = userOption[key];
      if (isObject(common) && isObject(user)) {
        option[key] = Object.assign({}, common, userOption[key] || {});
      }
    }
    return {
      ...commonOption,
      ...userOption,
      ...(option || {}),
    };
  }

  const options = useMemo(() => {
    if (noMerge) return userOptions;

    const optionsKey = optionsTypeMap[type]
      ?.concat(Object.keys(userOptions))
      ?.filter((key: any) => !excludeOptions.includes(key));
    const resultOptions: { [key: string]: any } = { ...userOptions };
    // console.log(optionsKey);
    optionsKey?.forEach((key) => {
      const userOption: any = userOptions[key]; // 用户配置内容
      const commonOption: any = commonOptions[key]; // 公共配置内容
      // 用户没有配置，公共有配置
      if (!userOption && commonOption) {
        resultOptions[key] = commonOption;
      }
      // 用户有配置，公共没有配置
      else if (userOption && !commonOption) {
        resultOptions[key] = userOption;
      }
      // 用户，公共都有配置, 最多两层的对象合并，没有必要深层次
      else {
        if (isObject(commonOption) && isObject(userOption)) {
          resultOptions[key] = mergeObjOptions(commonOption, userOption);
        } else if (isObject(commonOption) && isArray(userOption)) {
          resultOptions[key] = userOption.map((item) =>
            mergeObjOptions(commonOption, item),
          );
        } else {
          resultOptions[key] = userOption;
        }
      }
    });

    dealwithPie(resultOptions);
    dealwithBarLine(resultOptions);

    // type === 'line' && console.log(resultOptions, 'resultOptions');
    return resultOptions;
  }, [userOptions]);

  return options;
}
